import React from "react";
import "./Home.css";
import { scroller } from "react-scroll";
export default function Home() {
    const scrollToTours = () => {
    scroller.scrollTo("tours", {
      smooth: true,
      offset: -70, // navbar height
      duration: 600,
    });
  };
  return (
    <section id="home" className="hero-section">
      <div className="hero-overlay">
        <div className="hero-content">
          <h1>Explore Gjirokaster</h1>
          <p>“Walk through Gjirokaster’s traditional streets, uncover its rich history and culture, and experience its iconic stone architecture with knowledgeable local guides.”</p>
          <a href="#about" className="hero-btn" onClick={scrollToTours}>Our Tours</a>
        </div>
      </div>
    </section>
  );
}

